import Header from 'components/header';

import reit from  '../../assets/images/itreit_logo.jpg';
import house from 'assets/images/house.svg';
import styles from './styles.module.scss';
import { useEffect } from 'react';
import fetcher from '../../lib/fetcher';

const MainScreenContent: React.FC = () => {
  // call for check authorization
  useEffect(() => {
    fetcher.swr(`/facilities`, {
      method: 'get',
    });
  }, []);

  return (
    <div className={styles.container}>
      {/* <img className={styles.house} src={house} width={187} alt='Дом с ключём' /> */}
      <img className={styles.reit} src={reit} width={350} alt='Логотип reit' />
      <Header className={styles.text} text='Сервис умных сделок с недвижимостью' />
    </div>
  );
};

export default MainScreenContent;
